// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"c2185f25","239":"083cd478","413":"9f4b735d","448":"69d60f06","465":"db3e8361","695":"60cd6b1e"}[chunkId] + ".chunk.css";
};